// extracted by mini-css-extract-plugin
module.exports = {"itemTypes":"XoonipsTop_itemTypes__1tgd_","itemType":"XoonipsTop_itemType__xbLH4"};